import { findIndex, slice, startsWith } from 'lodash';
import { initializeCommand } from '../index';
import { execServices } from '../services';

export const command = 'exec';
export const describe = `Execute a command for all services with the correct environment variables.`;

export const builder = () => {
  initializeCommand();
};

export const handler = async(): Promise<void> => {
  const argv = process.argv;
  const execIndex = findIndex(argv, (argvPiece) => {
    return (argvPiece === command);
  });
  const binaryIndex = findIndex(argv, (argvPiece, argvIndex) => {
    if (argvIndex <= execIndex) {
      return false;
    }

    return !startsWith(argvPiece, '-');
  });
  const commandName = argv?.[binaryIndex]
  const commandArgv = slice(argv, binaryIndex + 1);

  execServices(commandName, commandArgv);
};